import { Component } from '@angular/core';
import { LoaderService } from './core/services/loader.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent {

  title = 'Profits Consulting - CRM';
  loading: Observable<boolean>;

  constructor(private loaderService: LoaderService) {
    this.loading = this.loaderService.loaderState;
  }
}
